module.exports = __webpack_public_path__ + "img/gold2.9cbeff54.png";